module.exports = __webpack_public_path__ + "static/media/play.94a19f07.svg";